import axios from "axios";

export async function getData(minValue, maxValue, searchType) {
  const request = {
    method: "GET",
    url: `https://cors-anywhere.herokuapp.com/https://api.dianurse.com/dianurse/v1/foodNavigator/glycemicIndex/json?page=1&limit=2000000&searchType=${searchType}&minValue=${minValue}&maxValue=${maxValue}&order=1&subdomain=bg`,
  };
  try {
    const response = await axios(request);
    return {
      data: response.data.results,
      meta: response,
    };
  } catch (e) {
    return [];
  }
}

export const getSearchedFood = async (keyword) => {
  try {
    const response = await axios.get(
      `https://cors-anywhere.herokuapp.com/https://api.dianurse.com/dianurse/v1/foodNavigator/searchForMatchWithinFoodNavigatorDatabase/json?keyword=${keyword}&subdomain=bg`,
    );
    return response.data;
  } catch (e) {
    return [];
  }
};
